import React                   from 'react';
import { Link }                from 'react-router-dom';
import { connect }             from 'react-redux';
import { Modal}                from 'react-bootstrap';
import FlashRetornoNulo        from '../../../container/FlashRetornoNulo';
import {  removerGruposTurmas, 
          GruposTurmas }       from '../../../actions/grupoAction';
import {  ActionModal }        from '../../../actions/scopoAction';
import EquipeForm              from './equipe_professor_form';


 class Equipe_Professor_Turma_List extends React.Component {

        constructor(props){
            super(props);
            this.state = {
              showModal : false,
              dis_id    : this.props.all_equipe_turma.dis_id,
              tur_id    : this.props.all_equipe_turma.tur_id,
              use_id    : this.props.session.id,
              dadosForm :[],
              acao : 0
            }           
        }

        formEquipe(ar){
            this.props.ActionModal(true);
            this.setState({dadosForm : this.props.all_equipes_ativas_professor[ar],acao:1})
        }

        removerEquipe(id){

          const acao  = window.confirm("Deseja Remover?");
          if (acao) {
            this.props.removerGruposTurmas(id);
           }
        }

        listarGrupos(){

            const listGruposTurmas = this.props.tipo_lista == null ? this.props.all_equipes_ativas_professor : this.props.all_equipes_inativas_professor;
           
                if (listGruposTurmas.length>0) {
                
                        return  listGruposTurmas.map((elem, valKey) =>{
                        
                          return  <tr id={`equipe_${elem.equ_id}`} key={valKey}>

                                  <td className="text-center">{elem.equ_id}</td>
                                  <td className="text-left">{elem.equ_nome}</td>
                                  <td className="text-center"> {elem.use_nome} </td>
                                  <td className="text-center">{elem.equ_qtd_alunos}</td>
                                  <td className="text-center">
                                     <button className="btn btn-warning btn-xs" onClick={this.formEquipe.bind(this,valKey)} disabled={this.props.tipo_lista != null ? true:false}><span className="glyphicon glyphicon-pencil"></span></button>
                                  </td>        
                                  <td className="text-center">
                                        <Link to={`${this.props.menu.equipe.professor.timeline_equipe}/${elem.equ_id}`} className="btn btn-primary btn-xs"><span className="glyphicon glyphicon-eye-open"></span></Link>
                                  </td>
                                  <td className="text-center">
                                  {this.props.tipo_lista != null ? <button className="btn btn-success btn-xs" disabled>
                                        <span className="glyphicon glyphicon-plus-sign"></span>
                                        </button>:
                                        <Link to={`${this.props.menu.equipe.professor.turma_aluno}/${elem.equ_id}/${this.state.dis_id}/${this.state.tur_id} `} className="btn btn-success btn-xs">
                                          <span className="glyphicon glyphicon-plus-sign"></span>
                                        </Link>
                                        }
                                  </td>
                          </tr>
                        });

                }else{

                     return <tr> <td colSpan={6} className="text-center"><FlashRetornoNulo/></td></tr>;
                }

        }

        componentWillReceiveProps(nextProps){
          if(nextProps.actionModal){
             this.setState({showModal: true });
          }else{
             this.setState({showModal: false,dadosForm:[],acao:0 });
          }
        }

        render() {
                const lar  = {width : '8%'}
                const lar2 = {width : '10%'}
                const lar3 = {width : '10%'}
                return (
                    <div>
                        <Modal show={this.state.showModal} bsSize="large" backdrop="static">
                          <EquipeForm
                            tipo        = {this.props.funcao_modal}
                            acao        = {this.state.acao}
                            dadosForm   = {this.state.dadosForm}
                            qtd_equipes = {this.props.all_equipes_ativas_professor.length}
                            />
                        </Modal>
                        <div className="panel panel-azul-claro panel-cinza">
                     
                          <div className="panel-body table-responsive">
                            <table className="table table_panel">
                              <thead> 
                                <tr> 
                                <th className="text-center" style={lar}>#</th>
                                <th className="text-left">Equipe</th> 
                                <th className="text-center">Criado por</th> 
                                <th className="text-center" style={lar2}>Qtd. Alunos</th>
                                <th className="text-center" style={lar2}>Editar</th>
                                <th className="text-center" style={lar2}>Ver Timeline</th>
                                <th className="text-center" style={lar3}>Alunos</th> 
                                </tr> 
                              </thead> 
                              <tbody> 
                                { this.listarGrupos() }
                              </tbody> 
                            </table>
                          </div>
                          </div>  
                    </div>);
        }

}


function mapStateToProps(state){

        return {

           all_equipe_turma      : state.equipeReducer.all_equipe_turma,
           session               : state.auth.session,
           nome_turma            : state.equipeReducer.nome_turma,
           menu                  : state.configReducer.menu,
           actionModal           : state.scopoReducer.actionModal,
           all_equipes_ativas_professor    : state.equipeReducer.all_equipes_ativas_professor,
           all_equipes_inativas_professor    : state.equipeReducer.all_equipes_inativas_professor,

        };
  }


export default connect(mapStateToProps,{ removerGruposTurmas,GruposTurmas,ActionModal })(Equipe_Professor_Turma_List)




// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor_turma_ativa.js